import type { ReactElement } from 'react';
import AccountDeletionScreen from '../screens/AccountDeletionScreen';
import PublicInformationScreen from '../screens/PublicInformationScreen';

export const publicInformationRoutes: readonly { path: string; element: ReactElement }[] = [
  { path: '/privacy', element: <PublicInformationScreen document="privacy" /> },
  { path: '/terms', element: <PublicInformationScreen document="terms" /> },
  { path: '/account-deletion', element: <AccountDeletionScreen /> },
] as const;
